import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.import', {
        url: '/import',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsImport'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.state.js